import { Inject, Injectable, Injector } from '@angular/core';


import { FootPrintApiManager_transaction_reportService } from './FootPrintApiManager.report.index';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootPrintApiManager: FootPrintApiManager_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
  private _transaction_report: FootPrintApiManager_transaction_reportService;
  public get transaction_report(): FootPrintApiManager_transaction_reportService {
    if(!this._transaction_report) {
      this._transaction_report = this.injector.get(FootPrintApiManager_transaction_reportService);
    }
    return this._transaction_report;
  }
}

